import { computed } from "vue";
import type { TabItem } from "@/components/Base/BaseTab/BaseTab.vue";

interface Props {
  modelValue: string;
  tabs: TabItem[];
}

export const useTabState = (
  props: Props,
  emit: ((event: "update:modelValue", value: string) => void) &
    ((event: "change", oldValue: string, newValue: string) => void),
) => {
  // Get only enabled tabs for navigation
  const enabledTabs = computed(() => props.tabs.filter((tab) => !tab.disabled));

  // Check if a tab is currently active
  const isActiveTab = (tabValue: string): boolean => {
    return props.modelValue === tabValue;
  };

  // Select a new tab
  const selectTab = (newValue: string): void => {
    if (newValue !== props.modelValue) {
      const oldValue = props.modelValue;
      emit("update:modelValue", newValue);
      emit("change", oldValue, newValue);
    }
  };

  return {
    enabledTabs,
    isActiveTab,
    selectTab,
  };
};
